import { styled } from "@mui/material/styles";
import { Slider } from "@mui/material";

const generateSVGDataUrl = (fillColor: string) => {
  const svg = `
    <svg width="9" height="13" viewBox="0 0 9 13" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#a)">
        <path d="M9 0L0 0L0 9.5L4.5 13L9 9.5L9 0Z" fill="${fillColor}"/>
      </g>
      <defs>
        <filter id="a" x="0" y="0" width="9" height="13" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix"
            values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="4" dy="4"/>
          <feGaussianBlur stdDeviation="2"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix"
            values="0 0 0 0 1  0 0 0 0 1  0 0 0 0 1  0 0 0 0.25 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
        </filter>
      </defs>
    </svg>
  `;
  return `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
};

export const StyledSlider = styled(Slider)(({ theme }) => ({
  color: theme?.palette?.components?.slider?.track || theme?.palette?.primary?.dark,
  height: "10px",
  padding: "20px 0 0 0 !important",
  "& .MuiSlider-thumb": {
    height: 20,
    width: 16,
    backgroundImage: generateSVGDataUrl(String(theme?.palette?.components?.slider?.thumbIcon)),
    backgroundSize: "100% 100%",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    border: "none",
    borderRadius: "0 0px 0px 0", // redondeado solo a la derecha, lado izquierdo plano
    cursor: "grab",
    backgroundColor: "transparent",
    zIndex: 1,
    "&::before": {
      boxShadow: "0 4px 8px rgba(0,0,0,0.4)",
    },
    "&:hover, &.Mui-focusVisible, &.Mui-active": {
      boxShadow: "none",
    },
  },
  "& .MuiSlider-thumb::before": {
    boxShadow: "none",
    content: "none",
  },
  "& .MuiSlider-markLabel": {
    fontSize: 13,
    fontWeight: 300,
    margin: "-10px 0px 0px 0px !important",
    color: theme?.palette?.components?.slider?.label,
  },
  "& .MuiSlider-rail": {
    opacity: 1,
    backgroundColor: theme?.palette?.components?.slider?.rail || "#d9d9d9",
  },
  "& .MuiSlider-mark": {
    display: "none",
  },
  "& .MuiSlider-valueLabel": {
    backgroundColor: "transparent",
    color: "#000",
    fontWeight: 600,
    top: 4,
  },
  // '& .MuiSlider-thumb': {

  // }
}));
